import { render, staticRenderFns } from "./likesComponnents.vue?vue&type=template&id=b179adc8&scoped=true"
import script from "./likesComponnents.vue?vue&type=script&lang=js"
export * from "./likesComponnents.vue?vue&type=script&lang=js"
import style0 from "./likesComponnents.vue?vue&type=style&index=0&id=b179adc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b179adc8",
  null
  
)

export default component.exports